"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.transactionAccordianBuilder = void 0;
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var transaction_header_1 = require("./transaction-header");
var transaction_body_1 = require("./transaction-body");
var ChargeSessionCodeType = ui_common_1.commonEnums.ChargeSessionCodeType;
var DRAGGABLE_CODES = new Set([
    ChargeSessionCodeType.MODIFIER,
    ChargeSessionCodeType.DIAGNOSIS
]);
/**
 * Method that builds an accordion element
 * @param handleKeyPress
 * @param handleBlurEvent
 * @param handleUnitsClick
 * @param handleCodeDelete
 * @param handleEnableTechPro
 * @param handleDisableTechPro
 * @param onFeatureSelection
 * @param panelActivations
 * @param medicalCode
 * @param idx
 * @param errors
 * @returns
 */
var transactionAccordianBuilder = function (handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, onFeatureSelection, isTimeBasedCode, timeBasedCodePopup, panelActivations, invoice, codeEdits, medicalCode, idx, codableTransaction, errors) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (errors === void 0) { errors = []; }
    var styleClasses = '';
    var techTransaction = {
        proCode: null,
        techCode: null,
        hasProCode: false,
        hasTechCode: false,
        isProCodeActive: false,
        isTechCodeActive: false,
        proContext: null,
        techContext: null,
        isModifier: false,
        isLoading: false
    };
    techTransaction.isLoading = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.isLoadingTechPro) !== null && _a !== void 0 ? _a : false;
    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
        // TORESOLVE: what should happen
    }
    else {
        styleClasses = "".concat(medicalCode.codeType, "-section");
        var modifierTransaction = (medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.codeType) === 'modifier'
            ? codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.modifiers.find(function (codableTransacMod) {
                return codableTransacMod.modifier_code === medicalCode.code;
            })
            : null;
        // assign tech/pro code if it exists
        if ((medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.codeType) === ui_common_1.commonEnums.CodeTypes.PROCEDURE &&
            ((_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _b === void 0 ? void 0 : _b.procedure_code) === (medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.code)) {
            techTransaction.isModifier = false;
            // add tech/pro for procedure
            techTransaction.proCode =
                (_d = (_c = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _c === void 0 ? void 0 : _c.procedure_code) !== null && _d !== void 0 ? _d : null;
            techTransaction.techCode =
                (_f = (_e = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _e === void 0 ? void 0 : _e.code) !== null && _f !== void 0 ? _f : null;
            techTransaction.hasProCode = !!((_g = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _g === void 0 ? void 0 : _g.procedure_code);
            techTransaction.hasTechCode = !!((_h = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _h === void 0 ? void 0 : _h.code);
            techTransaction.isProCodeActive = techTransaction.hasProCode
                ? (_j = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _j === void 0 ? void 0 : _j.active
                : false;
            techTransaction.isTechCodeActive = techTransaction.hasTechCode
                ? (_k = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _k === void 0 ? void 0 : _k.active
                : false;
            techTransaction.proContext = {
                transactionGuid: codableTransaction.guid,
                mappedProcedure: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) || null
            };
            techTransaction.techContext = {
                transactionGuid: codableTransaction.guid,
                technicalCode: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) || null
            };
        }
        else if ((medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.codeType) === ui_common_1.commonEnums.CodeTypes.MODIFIER) {
            // case for modifiers
            techTransaction.isModifier = true;
            if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === ui_common_1.commonEnums.ModifierTypes.PRO) {
                techTransaction.proCode =
                    (_p = (_m = (_l = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) === null || _l === void 0 ? void 0 : _l.procedure_code) !== null && _m !== void 0 ? _m : (_o = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _o === void 0 ? void 0 : _o.procedure_code) !== null && _p !== void 0 ? _p : '';
                techTransaction.hasProCode = true;
                techTransaction.isProCodeActive = true;
            }
            else if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === ui_common_1.commonEnums.ModifierTypes.TECH) {
                techTransaction.techCode =
                    (_r = (_q = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) === null || _q === void 0 ? void 0 : _q.code) !== null && _r !== void 0 ? _r : '';
                techTransaction.hasTechCode = true;
                techTransaction.isTechCodeActive = true;
            }
        }
    }
    return {
        className: (0, classnames_1["default"])(styleClasses),
        header: (0, transaction_header_1.Header)(medicalCode, techTransaction, errors, invoice, codeEdits, handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup),
        data: medicalCode,
        selectable: !ui_common_1.cmxTypeguards.isZippedCodeBlock(medicalCode),
        //@ts-ignore
        draggable: DRAGGABLE_CODES.has(medicalCode.codeType),
        id: "".concat(idx),
        body: (0, transaction_body_1.BuildBody)(medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection),
        open: false
    };
};
exports.transactionAccordianBuilder = transactionAccordianBuilder;
//# sourceMappingURL=transaction-accordion.js.map